var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 106,
    viewBox: "0 0 122 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6216 95.3336L92.1468 95.5135L91.9822 92.3342L95.457 92.1543L95.6216 95.3336Z",
    fill: "#2ECC71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6216 95.3336L92.1468 95.5135L91.9822 92.3342L95.457 92.1543L95.6216 95.3336Z",
    stroke: "#2ECC71",
    strokeWidth: 1.10941
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.903 47.1627L119.457 45.7917L120.82 50.3175L116.266 51.6885L114.903 47.1627Z",
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.903 47.1627L119.457 45.7917L120.82 50.3175L116.266 51.6885L114.903 47.1627Z",
    stroke: "#E74C3C",
    strokeWidth: 1.58037
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96257 27.6399L4.23493 24.5741L7.83095 26.0665L6.55859 29.1323L2.96257 27.6399Z",
    fill: "#F39C12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96257 27.6399L4.23493 24.5741L7.83095 26.0665L6.55859 29.1323L2.96257 27.6399Z",
    stroke: "#F39C12",
    strokeWidth: 1.19831
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0155 12.5527L47.4549 10.5324L49.4472 7.02118L53.0078 9.0415L51.0155 12.5527Z",
    fill: "#3498DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0223 88.6609L49.9619 89.3269L49.4279 85.2695L54.4883 84.6035L55.0223 88.6609Z",
    fill: "#2ECC71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0223 88.6609L49.9619 89.3269L49.4279 85.2695L54.4883 84.6035L55.0223 88.6609Z",
    stroke: "#2ECC71",
    strokeWidth: 1.52343
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9135 27.2524C91.3788 28.1099 91.0685 29.1796 90.2209 29.6395C89.3734 30.0994 88.3074 29.7766 87.8421 28.9192C87.3768 28.0617 87.6871 26.992 88.5346 26.5321C89.3822 26.0722 90.4481 26.3949 90.9135 27.2524Z",
    fill: "#2ECC71"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36306 40.8653C2.40465 41.2792 1.26705 40.783 0.824327 39.758C0.381606 38.7329 0.800301 37.5646 1.7587 37.1506C2.71711 36.7367 3.85471 37.2329 4.29743 38.2579C4.74015 39.283 4.32146 40.4513 3.36306 40.8653Z",
    fill: "#3498DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11944 103.352C8.22308 104.495 7.43256 105.503 6.35527 105.601C5.27797 105.698 4.31914 104.849 4.21549 103.706C4.11185 102.563 4.90237 101.555 5.97967 101.457C7.05696 101.36 8.01579 102.209 8.11944 103.352Z",
    fill: "#2ECC71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8842 78.0998C21.6478 76.7986 22.3945 75.5716 23.5505 75.3615C24.7066 75.1515 25.8371 76.0375 26.0735 77.3387C26.3099 78.64 25.5632 79.867 24.4072 80.077C23.2511 80.287 22.1206 79.401 21.8842 78.0998Z",
    fill: "#E74C3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2217 64.6537C42.3535 64.2257 42.0068 63.1515 42.4481 62.2563C42.8893 61.3612 43.9525 60.9819 44.8207 61.4099C45.689 61.8379 46.0357 62.9122 45.5944 63.8073C45.1532 64.7024 44.09 65.0817 43.2217 64.6537Z",
    fill: "#3498DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4122 101.457L50.4737 103.011L48.5352 104.564L48.1934 102.026L47.8515 99.4865L50.1318 100.472L52.4122 101.457Z",
    fill: "#F39C12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2528 97.0045L14.361 97.9367L12.4693 98.869L12.9548 96.365L13.4403 93.861L14.8465 95.4327L16.2528 97.0045Z",
    fill: "#2ECC71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9911 82.3002L75.1019 83.3443L73.2128 84.3883L73.4247 81.9856L73.6367 79.5828L75.3139 80.9415L76.9911 82.3002Z",
    fill: "#F39C12"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7922 34.986L95.8722 32.6184L95.9522 30.2508L97.8494 31.3136L99.7466 32.3764L97.7694 33.6812L95.7922 34.986Z",
    fill: "#2ECC71"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2252 0.641297L84.3425 2.91269L84.4599 5.18408L82.4632 4.19366L80.4664 3.20324L82.3458 1.92227L84.2252 0.641297Z",
    fill: "#E74C3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.972 2.7703L30.7372 4.73066L29.5024 6.69102L28.4464 4.3841L27.3904 2.07718L29.6812 2.42374L31.972 2.7703Z",
    fill: "#F39C12"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.345912 56.4282L1.24862 54.6327L2.15132 52.8373L3.23901 54.3554L4.32669 55.8734L2.3363 56.1508L0.345912 56.4282Z",
    fill: "#3498DB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0449 11.9556C95.5599 12.7069 98.2146 18.9148 100.606 23.2483",
    stroke: "#2ECC71",
    strokeWidth: 1.5692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.793 8.51562C81.3217 8.51562 99.6133 26.8072 99.6133 49.3359C99.6133 71.8647 81.3217 90.1562 58.793 90.1562C36.2642 90.1562 17.9727 71.8647 17.9727 49.3359C17.9727 26.8072 36.2642 8.51562 58.793 8.51562Z",
    fill: "#7B2928"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6797 49.6079L53.5916 60.5198L74.9036 38.1519",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4008bff2580d6cf8947791e230d026e5.svg";
export { ForwardRef as ReactComponent };